import React from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import {mobileMediaQuery} from '../../styles';

const Container = styled.ul`
    display: flex;
    padding: 0px;
    margin: 0;
    align-items: flex-start;
    flex-wrap: wrap;

    ${mobileMediaQuery} {
        width: 100%;
        flex-direction: column;
    }
`;

const Item = styled.li`
    font-size: 16px;
    font-weight: normal;
    height: auto;
    min-height: 22px;
    line-height: 22px;
    text-decoration: underline;
    display: inline-block;
    margin-right: ${props => (props.gap ? `${props.gap}px` : '')};
    cursor: pointer;
    white-space: nowrap;
    margin-bottom: 16px;

    a {
        color: #fff;
        margin: 0 !important;
        padding: 0;
        white-space: pre-line;
    }

    ${mobileMediaQuery} {
        margin-right: 0 !important;
    }
`;

const InlineNav = props => (
    <Container>
        {props.items.map(
            (item, index) =>
                item.url && (
                    <Item {...props} key={`k${index}`}>
                        {item.url[0] === '/' ? (
                            <Link to={item.url}>{item.title}</Link>
                        ) : (
                            <a
                                href={item.url}
                                target={'_blank'}
                                rel="noopener noreferrer"
                            >
                                {item.title}
                            </a>
                        )}
                    </Item>
                ),
        )}
    </Container>
);

export default InlineNav;
